module.exports = __webpack_public_path__ + "static/footer-2-13b5e1c94dddab8668e1d3a26a48e959.jpg";